import React, { PropTypes } from 'react';
import { selectify } from "../../businessLogic/util";
import Select from 'react-select';

export default class CreateNewUser extends React.Component {

	constructor(props) {
		super(props);
		// this.state = { isFetching: false, message: "", status: "" };
		this.forminfo = { };
	}

	componentWillMount() {
		this.props.getGroups();
		if ( window.location.href.includes("change_user") ) {
			this.props.actions.setEdit(true);
		} else {
			this.props.actions.setEdit(false);
		}
		this.props.actions.setMessage("");
	}

	handleSubmit(e) {
		e.preventDefault();
		e.stopPropagation();
		
		this.props.actions.isFetching(true);
		const userInfo = this.props.user;

		// const newPw = this._newPw.value;
		// const confirmPw = this._confirmPw.value;

		// if ( newPw !== confirmPw ) {
		// 	this.setState({status: "ERROR", message: "Senhas não conferem!"});
		// 	return;
		// }
		// const userInfo = this.forminfo;

		// Call action
		const isEdit = window.location.href.includes("change_user");
		let ops = isEdit ? "PUT" : "POST";
		this.props.actions.createNewUser(userInfo, this.onSuccess.bind(this), this.onError.bind(this), ops);
	}

	onSuccess(response) {
		this.props.actions.isFetching(false);
		this.props.actions.setMessage(response);
		this.props.actions.setStatus("SUCCESS");
	}

	onError(errorMessage) {
		this.props.actions.isFetching(false);
		this.props.actions.setMessage("Problema ao salvar alterações.");
		this.props.actions.setStatus("ERROR");
	}

	additionalText() {
		if ( this.props.newuser.isFetching )	return (<i className="fas fa-circle-notch fa-spin " />);
		return (
			<span style={{color: this.props.newuser.status === "SUCCESS" ? "green" : "red"}}>
				{this.props.newuser.message}
			</span>
		);
	}

	getTitle() {
		const isEdit = window.location.href.includes("change_user");
		if (isEdit) {
			return (
				<h2 className="text-center">Editar Usuário</h2>
			);
		} else {
			return (
				<h2 className="text-center">Criar Novo Usuário</h2>
			);
		}
			
	}

	getPasswordTitle() { 
		const isEdit = window.location.href.includes("change_user");
		if (isEdit) {
			return (<label>Nova Senha</label>);
		} else {
			return (<label>Senha</label>);
		}
	}

	render () {
		const { user, actions } = this.props; 
		return (
			<div className="container cad-user cs-card">
				{this.getTitle()}				
				<hr />				
				<div className="cad-user-content">
					<form onSubmit={this.handleSubmit.bind(this)}>
						<div className="col-md-5 personalInfo">
							<span className="subtitle-caduser">Dados Pessoais</span>
							<br></br>
							<br></br>
							<div className="form-group" style={{width: '330px'}}>
								<label>Nome</label>
								<input type="text" className="form-control" value={user.nome} 
								onChange={(e) => actions.setNome(e.target.value)} />
							</div>
							<div className="form-group" style={{width: '330px'}}>
								<label>Sobrenome</label>
								<input type="text" className="form-control" value={user.sobrenome}
								onChange={(e) => actions.setSobrenome(e.target.value)} />
							</div>
							<div className="form-group" style={{width: '330px'}}>
								<label>E-mail</label>
								<input type="email" className="form-control" value={user.email}
								onChange={(e) => actions.setEmail(e.target.value)} />
							</div>
							<hr></hr>
							<span className="subtitle-caduser">Dados de Acesso</span>
							<br></br>
							<br></br>
							<div className="form-group" style={{width: '330px'}}>
								<label>Nome de usuário</label>
								<input type="text" className="form-control" value={user.username}
								onChange={(e) => actions.setUsername(e.target.value)} />
							</div>
							<div className="form-group" style={{width: '330px'}}>
								{this.getPasswordTitle()}								
								<input type="password" className="form-control" value={user.password} 
								onChange={(e) => actions.setPassword(e.target.value)} />
							</div>
							<div className="form-group" style={{width: '330px'}}>
								<label>Confirme a Senha</label>
								<input type="password" className="form-control" value={user.confirmpassword} 
								onChange={(e) => actions.setConfirmPassword(e.target.value)} />
							</div>	
						</div>
						<div className="col-md-5" style={{marginLeft: '20px'}}>
							<span className="subtitle-caduser">Permissões</span>
							<br></br>
							<br></br>
							<div className="form-group">
								<label>Acesso a projetos</label>
								<br></br>
								<div className="row">
									<div className="col-md-6">
										<label>
										Mariana
											<input type="checkbox" className=""
											style={{marginLeft: '10px'}} checked={user.mariana} 
											onChange={(e) => actions.setMariana(e.target.checked)} />
										</label>
									</div>
									<div className="col-md-6">
										<label>
										Brumadinho
											<input type="checkbox" className="" 
											style={{marginLeft: '10px'}} checked={user.brumadinho}
											onChange={(e) => actions.setBrumadinho(e.target.checked)} />
										</label>
									</div>
								</div>

							</div>
							<div className="form-group" style={{width: '300px'}}>
								<label>Grupo Temático</label>
								<Select
										name="groups-select"
										options={selectify(this.props.groups.list.filter((group) => {
											if (user.mariana && (group.idProjeto === 1 || group.idProjeto === 3)) {
												return group;
											} else if (user.brumadinho && (group.idProjeto === 2 || group.idProjeto === 3)) {
												return group;
											}
										}))}
										value={this.props.user.selectedGroups}													
										placeholder="Selecionar Grupos"
										multi
										clearAllText="Limpar opções"
										onChange={(value) => actions.setNewUserGroups(value)}
									/>
							</div>
							<span style={{marginTop: "25px", position: "absolute"}}>
								{this.additionalText()}
							</span>
						</div>
						<br></br>

						<button 
							type="submit"
							disabled={this.props.newuser.isFetching}
							className="btn btn-primary"
							style={{ float: "right", marginRight: "150px", marginTop: "15px" }}>
							Cadastrar
						</button>
						<br></br>

					</form>
				</div>
				
			</div>
		);
	}
}

CreateNewUser.propTypes = {
	actions: PropTypes.object.isRequired,
	groups: PropTypes.object.isRequired,
	newuser: PropTypes.object.isRequired,
	user: PropTypes.object.isRequired,
	getGroups: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/ManageUser/CreateNewUser.js